// import React from "react";
import { Button, Col, Input, Row, Select, Tooltip, Form, Typography, Modal, message, Card, Empty } from "antd";
import React, { useState, useEffect } from "react";
import axiosClient from "../../Authentication/ApiCall";
import authService from "../../Authentication/authService";
import ClipLoader from "react-spinners/ClipLoader";
import { UserOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import _, { } from "lodash";
import { MdOutlineAddLocationAlt } from "react-icons/md";
import { FaNfcDirectional } from "react-icons/fa6";

const StoresConfiguration = () => {
    const { Text } = Typography;
    const [modal, setModal] = useState(false);
    const [form] = Form.useForm();
    const [editform] = Form.useForm();
    const [AddRefresh, setAddRefresh] = useState(1);
    const [Pageload, setPageload] = useState(false);
    const [tabledata, settabledata] = useState([]);
    const [editrecord, seteditrecord] = useState(null);
    const [editModal, seteditModal] = useState(false);
    const [Stores, setStores] = useState([]);
    const [cameras, setCameras] = useState([]);
    const [store, selectedStore] = useState("");
    const { Option } = Select;
    const onclickmodal = () => {
        setModal(true);
        form.resetFields();
    };

    const handlecreateeventclose = () => {
        setModal(false);
        form.resetFields();
    };

    const onFinish = (values) => {
        axiosClient
            .post("/storesConfig/addstoresconfigurationdetails ", {
                storeId: values.store,
                storesName: values.storesName,
                cameraIds: values.cameras,
            })
            .then((response) => {
                if (response.data.issuccess === true) {
                    message.success(response.data.data);
                    setAddRefresh(AddRefresh + 1);
                    setModal(false);
                    form.resetFields();
                }
            })
            .catch((err) => {
                setModal(false);
                setPageload(false);
                if (err.status === 0) {
                    message.error("Server error");
                } else {
                    message.error(err.msg);
                }
            });
    };

    const onEditRecord = (items) => {
        seteditModal(true);
        axiosClient
        .get("/storesConfig/getselectedcameradetails?id=" + items.id + "&storeId=" + items.storeId)
        .then((response) => {
            if (response.status === 200) {
                setCameras(response.data.camera)
                editform.setFieldsValue({
                    cameras: response.data.data,
                });
            }
        })
        .catch((err) => {
            if (err.status === 0) {
                message.error("Server error");
            } else {
                message.error(err.msg);
            }
        });
        editform.setFieldsValue({
            storeName: items.storeName,
            storesName: items.storesName
        });
    };

    const onChangestore = (value) => {
        selectedStore(value);
        axiosClient
            .get("/storesConfig/getcameradetails?id=" + value)
            .then((response) => {
                if (response.status === 200) {
                    setCameras(response.data.data)
                }
            })
            .catch((err) => {
                if (err.status === 0) {
                    message.error("Server error");
                } else {
                    message.error(err.msg);
                }
            });
    };

    const handleclose = () => { seteditModal(false); };

    const onFinishedit = (values) => {
        axiosClient
            .put("storesConfig/editstoresconfigurationdetails", {
                id: editrecord.id,
                storesName: values.storesName,
                cameraIds: values.cameras
            })
            .then((response) => {
                if (response.status === 200) {
                    // setPageload(false)
                    seteditModal(false);
                    setAddRefresh(AddRefresh + 1);
                    message.success(response.data.msg);
                } else {
                    setPageload(false);
                    message.error(response.data.msg);
                }
            })
            .catch((err) => {
                seteditModal(false);
                // setPageload(false)
                if (err.status === 0) {
                    message.error("Server error");
                } else {
                    message.error(err.msg);
                }
            });

        form.resetFields();
    };

    const onDeleteRecord = (items) => {
        Modal.confirm({
            title: (
                <div>
                    <h3>Confirm Delete?</h3>
                    <h4>
                        {" "}
                        Stores Configuration will be deleted
                    </h4>
                </div>
            ),
            okText: "Confirm",
            okType: "danger",
            onOk: () => {
                axiosClient
                    .get("/storesConfig/deletestoresconfigurationdetails?id=" + items.id)
                    .then((response) => {
                        if (response.data.issuccess === true) {
                            message.success(response.data.msg);
                            setAddRefresh(AddRefresh + 1);
                        } else {
                            setAddRefresh(AddRefresh + 1);
                        }
                    })
                    .catch((err) => {
                        if (err.status === 0) {
                            message.error("Server error");
                            setAddRefresh(AddRefresh + 1);
                        } else {
                            message.error(err.msg);
                        }
                    });
            },
        });
        form.resetFields();
    };

    const oncancelofform = () => {
        setModal(false);
        form.resetFields();
    };

    useEffect(() => {
        axiosClient
            .get("/flooronboard/getstoredetails")
            .then((response) => {
                if (response.data.issuccess === true) {
                    setStores(response.data.data);
                }
            })
            .catch((err) => {
                if (err.status === 0) {
                    message.error("Server error");
                } else {
                    message.error(err.msg);
                }
            });
    }, []);

    useEffect(() => {
        const fetchData1 = () => {
            axiosClient
                .get("/storesConfig/getstoresconfigurationdetails")
                .then((response) => {
                    if (response && response.data && response.data.data) {
                        const flattenedData = response.data.data.sort((a,b) => a.storesName.localeCompare(b.storesName)).flat();
                        settabledata(flattenedData);
                    }
                })
                .catch((err) => {
                    if (err.status === 0) {
                        message.error("Server error");
                    } else {
                        message.error(err.msg);
                    }
                });
        };

        fetchData1();
    }, [AddRefresh]);

    return (
        <>
            <div
                className="report-content"
                style={{
                    // height: "120px",
                    backgroundColor: "#000816",
                    width: "100%",
                    // marginLeft: "9px",
                    margin: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
            >
                {/* First Row */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginLeft: "3%",
                        padding: "10px",
                        marginTop: "10px",
                    }}
                >
                    <p
                        style={{
                            color: "white",
                            fontSize: "21px",
                            fontFamily: "revert-layer",
                        }}
                    >
                        Stores Configuration
                    </p>
                    <div style={{ display: "flex", marginRight: "3%" }}>
                        <Button
                            style={{ userSelect: "none" }}
                            className="adduser"
                            onClick={onclickmodal}
                        >
                            + New
                        </Button>
                    </div>
                </div>
            </div>

            <Modal
                className="onsubmitrtspmodal"
                destroyOnClose
                centered
                open={modal}
                onCancel={oncancelofform}
                title={
                    <>
                        <Row align={"middle"} justify={"center"}>
                            <Col>
                                <Text className="Modal-Header">Stores Configuration</Text>
                            </Col>
                        </Row>
                    </>
                }
                footer={
                    <>
                        <Row justify={"space-around"}>
                            <Col>
                                {authService.getCurrentUserReadOnly() ? (
                                    <Tooltip title="you need permission to submit">
                                        <Button type="primary" block disabled>
                                            Submit
                                        </Button>
                                    </Tooltip>
                                ) : (
                                    <Button
                                        className="primary-button"
                                        form="submitAdduserForm"
                                        type="primary"
                                        block
                                        htmlType="submit"
                                    >
                                        Submit
                                    </Button>
                                )}
                            </Col>
                            <Col>
                                <Button onClick={() => handlecreateeventclose()}>Cancel</Button>
                            </Col>
                        </Row>
                    </>
                }
            >
                <Row>
                    <Col
                        xs={{ span: 24, offset: 0 }}
                        sm={{ span: 24, offset: 0 }}
                        md={{ span: 24, offset: 0 }}
                        lg={{ span: 24, offset: 0 }}
                        xl={{ span: 24, offset: 0 }}
                        xxl={{ span: 24, offset: 0 }}
                    >
                        {" "}
                        <div style={{ marginTop: "20px" }}>
                            <Form
                                id="submitAdduserForm"
                                // layout="vertical"
                                form={form}
                                name="basic"
                                onFinish={onFinish}
                                autoComplete={"off"}
                                style={{ padding: "27px" }}
                            >
                                <Form.Item
                                    labelCol={{
                                        span: 9,
                                    }}
                                    wrapperCol={{
                                        span: 10,
                                    }}
                                    label="Store"
                                    name="store"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Select Store!",
                                        },
                                    ]}
                                >
                                    <Select
                                        style={{ width: 200 }}
                                        placeholder="Select a store"
                                        onChange={onChangestore}
                                    >
                                        {Stores.map((store) => (
                                            <Option key={store.id} value={store.id}>
                                                {store.storeName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    // className="top-space"
                                    labelCol={{
                                        span: 9,
                                    }}
                                    wrapperCol={{
                                        span: 11,
                                    }}
                                    label="Stores Name"
                                    name="storesName"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter your stores Name!",
                                        },
                                    ]}
                                >
                                    <Input
                                        style={{ width: 200 }}
                                        placeholder="Stores Name"
                                        prefix={<UserOutlined className="site-form-item-icon" />}
                                    />
                                </Form.Item>
                                <Form.Item
                                    labelCol={{
                                        span: 9,
                                    }}
                                    wrapperCol={{
                                        span: 10,
                                    }}
                                    label="Camera"
                                    name="cameras"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Select Camera!",
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option?.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                        mode="multiple"
                                        style={{ width: 200 }}
                                        placeholder="Select an camera"
                                    >
                                        {cameras.map((cam) => (
                                            <Option key={cam.value} value={cam.value}>
                                                {cam.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                            </Form>
                        </div>
                    </Col>
                </Row>
            </Modal>

            <Modal
                className="LoadinModal"
                open={Pageload}
                style={{ background: "none", textAlign: "center" }}
                footer={false}
                closable={false}
                centered
            >
                <ClipLoader
                    color="#23234d"
                    loading={Pageload}
                    cssOverride={{
                        display: "block",
                        margin: "0 auto",

                        borderWidth: "5px",
                        marginBottom: "10px",
                    }}
                    size={100}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                    title="Loading..."
                />
                <Text style={{ color: "white", fontSize: "1.2em" }}>Loading ...</Text>
            </Modal>

            <Row
                gutter={[10, 10]}
                align={"middle"}
                justify={"center"}
                style={{ marginTop: "18px" }}
            >
                <Col
                    xs={{ span: 24, offset: 0 }}
                    sm={{ span: 24, offset: 0 }}
                    md={{ span: 24, offset: 0 }}
                    lg={{ span: 24, offset: 0 }}
                    xl={{ span: 23, offset: 0 }}
                    xxl={{ span: 23, offset: 0 }}
                >
                    {tabledata.length > 0 ? (
                        <Row gutter={[6, 6]}>
                            {tabledata.map((items) => (
                                <Col
                                    xs={{ span: 14, offset: 0 }}
                                    sm={{ span: 14, offset: 0 }}
                                    md={{ span: 14, offset: 0 }}
                                    lg={{ span: 14, offset: 0 }}
                                    xl={{ span: 4, offset: 0 }}
                                    xxl={{ span: 4, offset: 0 }}
                                >
                                    <Card
                                        hoverable
                                        title={items.storeName + " - " + items.storesName}
                                        styles={{
                                            title: { textAlign: "center" },
                                            body: { padding: 0 },
                                            height: "300px",
                                        }}
                                    >
                                        <div
                                            className="border-line"
                                            style={{ borderBottom: "1px solid #d9d0d0" }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    padding: "0 16px",
                                                }}
                                            >
                                                <Button
                                                    type="text"
                                                    icon={<EditOutlined />}
                                                    onClick={() => {
                                                        onEditRecord(items);
                                                        seteditrecord(items);
                                                    }}
                                                />

                                                <Button
                                                    type="text"
                                                    icon={<DeleteOutlined style={{ color: "red" }} />}
                                                    // onClick={handleDelete}
                                                    onClick={() => {
                                                        onDeleteRecord(items);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "230px",
                            }}
                        >
                            <Empty />
                        </div>
                    )}
                </Col>
            </Row>

            <Modal
                title="Edit Record"
                onCancel={() => seteditModal(false)}
                centered
                open={editModal}
                footer={
                    <>
                        <Row justify={"space-around"}>
                            <Col>
                                {authService.getCurrentUserReadOnly() ? (
                                    <Tooltip title="you need permission to submit">
                                        <Button type="primary" block disabled>
                                            Submit
                                        </Button>
                                    </Tooltip>
                                ) : (
                                    <Button
                                        className="primary-button"
                                        form="submiteditform"
                                        type="primary"
                                        block
                                        htmlType="submit"
                                    >
                                        Submit
                                    </Button>
                                )}
                            </Col>
                            <Col>
                                <Button onClick={() => handleclose()}>Cancel</Button>
                            </Col>
                        </Row>
                    </>
                }
            // onCancel={handleCancel}
            >
                <Form
                    form={editform}
                    id="submiteditform"
                    name="basic"
                    onFinish={onFinishedit}
                    autoComplete={"off"}
                >
                    <Form.Item
                        labelCol={{
                            span: 9,
                        }}
                        wrapperCol={{
                            span: 10,
                        }}
                        label="Store Name"
                        name="storeName"
                        rules={[
                            {
                                required: true,
                                message: "Please enter your Store Name!",
                            },
                        ]}
                    >
                        <Input
                            style={{ width: 200 }}
                            placeholder="Store Name"
                            prefix={<UserOutlined className="site-form-item-icon" />}
                            disabled={true}
                        />
                    </Form.Item>
                    <Form.Item
                        // className="top-space"
                        labelCol={{
                            span: 9,
                        }}
                        wrapperCol={{
                            span: 10,
                        }}
                        label="Stores Name"
                        name="storesName"
                        rules={[
                            {
                                required: true,
                                message: "Please enter your stores Name!",
                            },
                        ]}
                    >
                        <Input style={{ width: 200 }}  />
                    </Form.Item>
                    <Form.Item
                        labelCol={{
                            span: 9,
                        }}
                        wrapperCol={{
                            span: 10,
                        }}
                        label="Camera"
                        name="cameras"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Camera!",
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option?.children.toLowerCase().includes(input.toLowerCase())
                            }
                            mode="multiple"
                            style={{ width: 200 }}
                            placeholder="Select an camera"
                        >
                            {cameras.map((cam) => (
                                <Option key={cam.value} value={cam.value}>
                                    {cam.label}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                </Form>
            </Modal>
        </>
    );
};
export default StoresConfiguration;
